import { Box, Menu, MenuItem } from "@mui/material"
import React from "react"
import { useTheme } from "@emotion/react"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import editIcon from "assets/icons/edit.svg"
import archiveIcon from "assets/icons/UnarchiveItem.svg"
import trashIcon from "assets/icons/trash.svg"

const styles = {
  icon: {
    width: "20px",
    cusor: "pointer",
    marginRight: "8px"
  }
}

const MenuAction = ({
  open,
  anchorEl,
  handleMenuClick,
  handleClose,
  handleClick,
  itemId,
  categoryIdData,
  item,
  isReviewMode = false,
  isPreview = true,
  backgroundColor
}) => {
  const theme = useTheme()
  return (
    <div>
      <MoreVertIcon
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={(e) => handleMenuClick(e)}
        sx={{ cursor: "pointer" }}></MoreVertIcon>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        PaperProps={{
          sx: {
            backgroundColor: theme.palette.primary.main,
            color: "#fff"
          }
        }}
        BackdropProps={{
          sx: {
            backgroundColor: backgroundColor || "rgba(0, 0, 0, 0.5)"
          }
        }}>
        <MenuItem
          onClick={() => handleClick("edit", itemId, categoryIdData, item)}
          sx={{ width: "180px" }}>
          <Box component="img" src={editIcon} alt="edit" sx={styles.icon} />
          Edit{!!isPreview && " & Preview"}
        </MenuItem>
        {!isReviewMode && (
          <MenuItem
            onClick={() => handleClick("archive", itemId, categoryIdData, item)}
            sx={{ width: "180px" }}>
            <Box component="img" src={archiveIcon} alt="edit" sx={styles.icon} />
            Archive
          </MenuItem>
        )}
        <div style={{ height: "2px", background: "#2C2C2C" }} />
        <MenuItem
          onClick={() => handleClick("delete", itemId, categoryIdData, item)}
          sx={{ color: theme.palette.red.main }}>
          <Box component="img" src={trashIcon} alt="edit" sx={styles.icon} />
          Delete
        </MenuItem>
      </Menu>
    </div>
  )
}

export default MenuAction
